/*
 * @Author: jiahuacui
 * @Date: 2018-08-09 14:31:10
 * @LastEditors: jiahuacui
 * @LastEditTime: 2018-08-08 14:31:10
 * @Description: 
 */
<!-- 
  BOM清单
  相关 JavaScript脚本在config/mixin文件中
 -->
<template>
  <div class="list bomBill-page">
    <list-head @searchEmit="search" placeholder="请输入BOM、成品进行搜索">
      <span slot="title">
        BOM清单管理
        <span class="version">公测版</span>
        <span class="hint">此模块为测试版本，不属于现阶段收费范畴，期待与您进行需求共创！</span>
      </span>
      <template slot="options" v-for="btn in topPermission">
        <el-button size="small" v-if="btn === 'add'" type="primary" @click="addnew">{{topMap[btn]}}</el-button>
        <el-button size="small" v-else @click="topBtnHandle(btn)">{{topMap[btn]}}</el-button>
      </template>
    </list-head>
    <div class="content">
      <list-panel ref="panel"  :sortArray="sortArray" @ssChange="refreshTable" @refresh="getList" :belonger="belonger"></list-panel>

      <list-table
        ref="table"
        :summaryInfo = "summaryInfo"
        :tableHead="listHead"
        :tableData="listData"
        :listMenu="hasListMenu"
        @details="openDetail"
        @edit="editItem"
        @refresh="getList"
        @recall="handleRecall">
      </list-table>
      
      <div class="foot-wrapper">
        <list-footer
          ref="foot"
          :permission="botPermission"
          @deleteArr="deleteRows"
          @cancelCheck="cancelTableCheck"
          @archived="handlePerm">
        </list-footer>
        
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <transition name="slide">
      <detail
        ref="detail"
        v-if="detailShow"
        :id="detailId"
        :moduleName="popModel"
        @addNew="newWorkFlow"
        @close="closeDetail"
        @refresh="getList"
        @edit="editItem"
        @recall="handleRecall">
      </detail>
    </transition>
    <transition name="fade">
      <div class="detail-bg" v-if="detailShow" @click="detailShow=false"></div>
    </transition>
    <Print v-if="choosePrintType" 
      :entityIdProp="printIds"
      :moduleName="moduleName"
      :refType="refType"
      @closeDialog="choosePrintType = false"
      >
    </Print>
    <export v-if="exportShow" @export="exportFile" @closeDialog="closeExport"></export>
    <batch-edit v-if="batchEditShow" :selectIds="getSelectIds" @refresh="success" @closeDialog="batchEditShow = false"></batch-edit>
    </div>
</template>

<script>
import * as mixin from 'src/config/mixin'

export default {
  created () {
    this.initList('bomBill')
    this.getList()
  },
  mixins: [mixin.list]
}
</script>
<style lang="less" scoped>
.bomBill-page {
  .version {
    display: inline-block;
    width: 50px;
    height: 20px;
    line-height: 20px;
    background-color: rgba(252, 242, 222, 1);
    color: rgba(254, 157, 79, 1);
    font-size: 11px;
    text-align: center;
    margin: 0 8px 0 8px;
  }
  .hint {
    line-height: 16px;
    color: rgba(255, 124, 53, 1);
    font-size: 11px;
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?13848e30